import React, { useEffect, useState } from 'react';
import MaskReal from 'services/formateRS';

import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"

import api from "assets/services/api";


function ModalAddTabulation(props) {

    const [br, setBR] = useState(false);


    const [productId, setProductId] = useState();
    const [products, setProducts] = useState([]);
    const [price_of_product, setPrice_of_product] = useState();
    const { storageId, storageUserType, user } = useAuth();
    const [controlSnack, setControlSnack] = useState(false);

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        loadProducts()
    }, []);

    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);

    async function loadProducts() {
        const id = storageUserType === "admin" ? storageId : user.id_admin
        const response = await api.get('product/admin/' + id)
        setProducts(response.data)
    }

    async function handleAddTabulation(e) {
        e.preventDefault();
        const response = await api.post('/tabulation', {
            price_of_product,
            id_client: props.id_client,
            id_product: productId ? productId : products[0].id,
            id: storageId,
            storageUserType
        });
        if (response.status === 200) {
            setControlSnack(true);
            props.handleShowTabulation();
            props.onHide();
        }

    }

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Adicionar tabela de preço
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleAddTabulation}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridSellsman">
                            <Form.Label>Produtos</Form.Label>
                            <Form.Control onChange={event => setProductId(event.target.value)} value={productId} as="select" defaultValue="Choose...">
                                {products.map(product => (
                                    <option key={String(product.id)} value={product.id}>{product.name}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Label>Valor de venda do produto</Form.Label>
                            <MaskReal value={price_of_product} onChange={value => setPrice_of_product(value.replace(',', '.'))} />
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Adicionar
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Tabela de preço adicionado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalAddTabulation;